import { render, staticRenderFns } from "./formTransferCertificate.vue?vue&type=template&id=235adbfb&"
import script from "./formTransferCertificate.vue?vue&type=script&lang=js&"
export * from "./formTransferCertificate.vue?vue&type=script&lang=js&"
import style0 from "./formTransferCertificate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports